<template>
    <div id="lookupCom">
        <a-modal :title="$t('pubGicSet.Lookup')" v-model="visible" width="80%">
            <template slot="footer">
                <a-popconfirm
                        :title="$t('publicLang.Arecancel')"
                        @confirm="handleCancel"
                        :okText="$t('publicLang.Yes')"
                        :cancelText="$t('publicLang.No')"
                >
                   <a-button type="primary" size="small">{{ $t('publicLang.Cancel') }}</a-button>
                </a-popconfirm>
            </template>
            <a-row type="flex" justify="space-between" style="margin-bottom: 6px;">
                <a-col>
                    <a-icon type="search" style="margin-right: 4px;"/>
                    <a-select style="width: 160px" size="small" @change="lookupTemplateData" v-model="lookupTemplateName" :placeholder="$t('publicLang.PleaseSelect')">
                        <a-select-option
                                :value="item"
                                v-for="item in lookupTemplateSelect"
                        >{{ item }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col>
                    <a-row type="flex" justify="start">
                        <a-col v-if="isPage">
                            <a-pagination
                                :showTotal="total => `${$t('generic.totalOf')} ${page.pagingTotal} ${$t('generic.Records')}`"
                                size="small"
                                :total="page.pagingTotal"
                                v-model="page.currentVal"
                                :pageSize.sync="page.pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger
                                />
                        </a-col>
                        <a-col>
                            <a-dropdown>
                                <span class="sbxs">
                                    <img src="../../../assets/img/ss-more.png"  width="15" height="15">
                                </span>
                                <a-menu slot="overlay">
                                    <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
                                        <a-icon type="zoom-in" />{{ $t('pubGicSet.AdvanceSearch') }}
                                    </a-menu-item>
                                    <a-menu-item style="font-size: 12px" @click="searchSort">
                                        <a-icon type="ordered-list" /> {{ $t('pubGicSet.AdvanceSort') }}
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <div class="example" v-if="!isTable">
                <a-spin />
            </div>
            <vxe-table
                    v-if="isTable"
                    stripe
                    border
                    highlight-hover-row
                    resizable
                    :data.sync="data"
                    size="mini"
                    :loading="lookupLoading"
                    max-height="350"
                    @cell-dblclick="dbcellClickEvent"
                    @header-cell-dblclick="headerCellDbclick"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <template v-for="(item, index) in cols">
                    <vxe-table-column
                            show-header-overflow="ellipsis" show-overflow="ellipsis"
                            :key="index"
                            :width="item.proWidth == null ? '200' : item.proWidth"
                    >
                        <template v-slot:header="{ column }">
                            <span>{{ item.title }}</span>
                            <div style="display: flex;align-items: center" v-if="isHeaderSearchFlag">
                                <input
                                        type="text"
                                        placeholder="Search"
                                        style="width: 50%;border-right: none;"
                                        size="small"
                                        v-model="item.serVal"
                                        @keyup.enter="searchTitleCont"
                                />
                                <span style="background: #fff;border: 1px solid #efefef;padding: 0 2px;cursor:pointer">
                      <a-icon type="search"  @click="searchTitleCont"/>
                </span>
                                <span style="display: inline-block;">
                      <a-icon type="caret-up" class="sortBtnClass" @click="locaSort(1, item)"/>
                      <a-icon type="caret-down" class="sortBtnClass" @click="locaSort(-1, item)"/>
                    </span>
                            </div>
                        </template>
                        <template v-slot="{ row }">
                            <div>
                <span>{{
                    row[item.label].value == null ? "-" : row[item.label].value
                    }} <a-button v-if="row[item.label].config.fieldType == 'LOOKUP'" type="primary" shape="circle" icon="plus" size="small" @click="neibuLookupEvet"></a-button></span
                >
                            </div>
                        </template>
                    </vxe-table-column>
                </template>
            </vxe-table>
        </a-modal>

        <!--Advance search-->
        <a-modal
            :title="$t('pubGicSet.AdvanceSearch')"
            v-model="AdvanceSearchVis"
            width="80%">
            <template slot="footer">
                <a-button type="primary" @click="getQueryFilter" size="small">{{ $t('pubGicSet.Search') }}</a-button>
            </template>
            <a-row>
                <a-col :span="18">
                    <a-row type="flex" justify="start">
                        <a-col style="margin-right: 5px;">
                            <span>{{ $t('pubGicSet.SearchTemplate') }}: </span>
                        </a-col>
                        <a-col>
                            <a-select
                                size="small"
                                style="width: 240px"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-model="targetAdvanceTml"
                                @change="changeTamplateAdvace">
                                <a-select-option
                                        :value="item"
                                        v-for="item in AdvanceTemplate"
                                >{{ item }}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col style="margin: 0 4px">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('generic.Add') }}</span>
                                </template>
                                <img @click="showAddTemplatName" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                            </a-tooltip>
                        </a-col>
                        <a-col>
                            <a-popconfirm
                                    :title="$t('pubGicSet.AreyoudeleTask')"
                                    :okText="$t('pubGicSet.Yes')"
                                    :cancelText="$t('pubGicSet.No')"
                                    @confirm="deleteTemplatName"
                            >
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>{{ $t('pubGicSet.delete') }}</span>
                                    </template>
                                    <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                                </a-tooltip>
                            </a-popconfirm>
                        </a-col>
                        <a-col style="margin: 0 4px">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('publicLang.Save') }}</span>
                                </template>
                                <img @click="saveTemplateVers" class="sbxs" src="../../../assets/img/ss-save.png" width="20" height="20">
                            </a-tooltip>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row>
                <loook-or
                    :options="options"
                    :isFirst="isFirst"
                    ref="andOrLookup"
                ></loook-or>
            </a-row>
        </a-modal>
        <!--添加Advance search temalate name-->
        <a-modal :title="$t('generic.Add')" v-model="AdchNameVis">
            <template slot="footer">
                <a-button size="small" type="primary" @click="SaveTamplateName">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="AdchNameFrom">
                <a-form-item :label="$t('pubGicSet.Name')" v-bind="formItemLayout">
                    <a-input
                        v-decorator="[
                              'template',
                              { rules: [{ required: true, message: $t('publicLang.Required')}] }
                            ]"
                        :placeholder="$t('pubGicSet.Name')"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
        <!--排序-->
        <a-modal :title="$t('pubGicSet.Sort')" v-model="searchSortVis" width="50%">
            <template slot="footer">
                <a-button type="primary" @click="getUpdateEvent">{{ $t('pubGicSet.Search') }}</a-button>
            </template>
            <div style="height: 70vh;">
                <vxe-table
                        border
                        height="auto"
                        class="sortable-row-demo vxe-table-antd"
                        row-key
                        size="mini"
                        ref="lookupComSortTable"
                        :data.sync="editTableData"
                        :edit-config="{ key: 'detaileUid', trigger: 'click', mode: 'row' }"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <vxe-table-column
                            field="fieldName"
                            show-header-overflow="ellipsis" show-overflow="ellipsis"
                            :title="$t('pubGicSet.FieldName')"
                    ></vxe-table-column>
                    <vxe-table-column
                            field="orderBy"
                            :title="$t('pubGicSet.OrderBy')"
                            width="140"
                            show-header-overflow="ellipsis" show-overflow="ellipsis"
                            :edit-render="{ type: 'visible' }"
                    >
                        <template v-slot:edit="{ row, rowIndex }">
                            <a-switch
                                    v-model="row.orderBy"
                                    checkedChildren="asc"
                                    unCheckedChildren="desc"
                                    size="small"
                            ></a-switch>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import loookOr from "../../com/queryBuilder/components/AndOR.vue";
    import Sortable from "sortablejs";
    import cookie from '../../../api/cookie';
    export default {
        components: {
            loookOr
        },
        props: {
            lookupdata: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        watch: {
            lookupdata(val) {
                if (val.gmcUid != "") {
                    this.isTable = false
                    this.initdata();
                }
            }
        },
        data() {
            return {
                searchSortVis: false,
                editTableData: [],

                lookupTemplateName:'',
                lookupTemplateSelect: [],
                page: {
                    pagingTotal: 10,
                    currentVal: 1,
                    pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30')
                },
                visible: false,
                data: [],
                cols: [],
                isTable: false,
                isPage: true,
                AdvanceSearchVis: false,
                AdchNameVis: false,
                resLookUpDetail: "",
                AdvanceTemplate: [],
                options: {
                    // query filter 下拉
                    condition: [],
                    fieldNameSel: []
                },
                AdchNameFrom: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                isFirst: true,
                targetAdvanceTml: undefined,
                LokkupAdvanuserSqlDto: {},
                lookupLoading: false,
                lookupUserSortDtos: [],
                lookupSearchTitle: [],
                searTypeLookup: '',
                isHeaderSearchFlag: false,
                LookupsortKey: '',
                lookupSortType: ''
            };
        },
        computed: {

        },
        methods: {
            neibuLookupEvet(){
                this.$refs.asdasd.showModal();
            },
//      表头搜索start
            headerCellDbclick(){
                this.isHeaderSearchFlag = !this.isHeaderSearchFlag
            },
            compare(propertyName) {
                return (object1, object2) => {
                    let a =
                        object1[propertyName].value == null
                            ? "9"
                            : object1[propertyName].value;
                    let b =
                        object2[propertyName].value == null
                            ? "9"
                            : object2[propertyName].value;
                    if (a < b) {
                        return this.lookupSortType * 1;
                    } else if (a > b) {
                        return this.lookupSortType * -1;
                    }
                    return 0;
                };
            },
            dataTest() {
                let that = this;
                let tableData = this.data;
                let sortKey = this.LookupsortKey;
                if (sortKey) {
                    this.data = tableData.sort(that.compare(sortKey));
                }
                this.data = tableData
                this.$forceUpdate()
            },
            locaSort(type, item) {
                this.LookupsortKey = item.label;
                this.lookupSortType = type;
                this.dataTest()
            },
            searchTitleCont(){
                let scParams = [];
                let columns = this.cols
                columns.forEach((v, i) => {
                    if (v.serVal) {
                        scParams.push({ key: v.uid, value: v.serVal });
                    }
                });
                this.searTypeLookup = 'tel'
                this.lookupSearchTitle = scParams
                this.page.currentVal = 1
                this.initdata(0)
            },
            lookupTemplateData(val){
                this.targetAdvanceTml = val
                this.page.currentVal = 1
                this.LokkupAdvanuserSqlDto = {gmcUid: this.resLookUpGmcUid, template: this.targetAdvanceTml}
                this.searTypeLookup = 'advan'
                this.initdata(0)
            },
            //      表头搜索 end
//      save one 保护模板
            saveTemplateVers(){
                if(this.targetAdvanceTml != ''){
                    let params = this.$refs.andOrLookup.queryFormStatus();
                    params.template = this.targetAdvanceTml
                    params.gmcUid = this.resLookUpGmcUid;
                    ajax.post(api.QUERYFILTER, params).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseFirst'));
                }
            },
            tableChangePage(current){
                this.page.currentVal = current
                this.initdata(0)
            },
            onShowSizeChange(current, pageSize){
                this.page.currentVal = 1
                this.page.pagingSize = pageSize
                this.initdata(0)
            },
            handleCancel(){
                this.visible = false;
            },
            //            双击当前行请求
            dbcellClickEvent({ row }) {
                if(this.lookupdata.noEvent){
                    return
                }
                let params = this.lookupdata;
                params.lookup.dataUid = row.uid;
                params.lookup.params = this.lookupdata.lookup.params
                this.$emit("propsLookupData", params);
                this.visible = false;
            },
            initdata(type=1) {
                this.lookupLoading = true;
                let params = {
                    gmcUid: this.lookupdata.lookup.gmcUid,
                    language: this.lookupdata.language,
                    params: this.lookupdata.feildArr,
                    paging: {
                        pageNum: this.page.currentVal,
                        pageSize: this.page.pagingSize
                    }
                };
                if(this.searTypeLookup == 'sort'){
                    params.userSortDtos = this.lookupUserSortDtos
                }else if(this.searTypeLookup == 'advan'){
                    params.userSqlDto = this.LokkupAdvanuserSqlDto
                } else if(this.searTypeLookup == 'tel'){
                    params.columnSearch = this.lookupSearchTitle
                }
                ajax.post(api.SKUS, params).then(res => {;
                    this.searTypeLookup = ''
                    this.resLookUpGmcUid = res.data.gmcUid;
                    this.data = res.data.tableList.data;
                    if(type == 1){
                        this.cols = res.data.tableList.columns;
                    }
                    if(res.data.tableList.paging != null ){
                        this.page.pagingTotal = res.data.tableList.paging.totalPageSize
                    }else{
                        this.isPage = false
                    }
                    this.isTable = true;
                    this.lookupLoading = false;
                    ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.resLookUpGmcUid }).then(res => {
                        this.lookupTemplateSelect = res.data
                        if(this.lookupTemplateSelect.length> 0){
                            this.lookupTemplateName = this.lookupTemplateSelect[0]
                        }
                    });
                });
            },
            showModal() {
                this.visible = true;
            },
//    handleOk(e) {
//      let lookupSelect = this.$refs.lookupTable.getCheckboxRecords();
//      if (lookupSelect.length != 1) {
//        this.$customMessage.error("Please select one record only.");
//        return;
//      } else {
//        let params = this.lookupdata;
//        params.lookup.dataUid = lookupSelect[0].uid;
//        params.lookup.params = this.lookupdata.lookup.params
//        this.$emit("propsLookupData", params);
//        this.visible = false;
//      }
//    },
            //            获取advan弹窗详情
            AdvanceSearch() {
                this.AdvanceSearchVis = true;
                ajax
                    .get(api.ADVANCETEMPLATE, { gmcUid: this.resLookUpGmcUid })
                    .then(res => {
                        this.AdvanceTemplate = res.data;
                        this.targetAdvanceTml = this.AdvanceTemplate[0];
                    });
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
                let params = {
                    gmcUid: this.resLookUpGmcUid
                };
                ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                    this.options.fieldNameSel = res.data;
                });

                let queryParams = {
                    gmcUid: this.resLookUpGmcUid
                };
                ajax.get(api.QUERYFILTER, queryParams).then(res => {
                    let queryObj = res.data;
                    this.$refs.andOrLookup.fillFormStatus(queryObj);
                });
                this.AdvanceSearchVis = true;
            },
            showAddTemplatName() {
                this.AdchNameVis = true;
            },
            getQueryFilter() {
                this.LokkupAdvanuserSqlDto = this.$refs.andOrLookup.queryFormStatus();
                this.searTypeLookup = 'advan'
                this.initdata();
                this.AdvanceSearchVis = false;
            },
            changeTamplateAdvace(val) {
                let params = {
                    gmcUid: this.resLookUpGmcUid,
                    template: val
                };
                ajax.get(api.QUERYFILTER, params).then(res => {
                    let queryObj = res.data;
                    this.$refs.andOrLookup.fillFormStatus(queryObj);
                });
            },
            deleteTemplatName(val) {
                let params = {
                    gmcUid: this.resLookUpGmcUid,
                    templateName: this.targetAdvanceTml
                };
                ajax.post(api.DELETETEMPLATE, params).then(res => {
                    if (res.code == 200) {
                        this.AdvanceSearch();
                    }
                });
            },
            SaveTamplateName() {
                this.AdchNameFrom.validateFields((error, values) => {
                    if (!error) {
                        let params = this.$refs.andOrLookup.queryFormStatus();
                        params.template = values.template;
                        params.gmcUid = this.resLookUpGmcUid;
                        ajax.post(api.QUERYFILTER, params).then(res => {
                            if (res.code == 200) {
                                this.AdvanceSearch();
                                this.AdchNameVis = false;
                            }
                        });
                    }
                });
            },
            searchSort(){
                this.$message.success(this.$t('publicLang.DragTheListTosort'))
                let gmcUid = this.resLookUpGmcUid ;
                this.searchSortVis = true;
                ajax.get(api.SEARCHSORT, { gmcUid: gmcUid }).then(res => {
                    this.editTableData = res.data;
                    let checkboArr = [];
                    this.editTableData.forEach((v, i) => {
                        v.orderBy = v.orderBy == 0 ? false : true;
                        if (v.isSort == "1") {
                            checkboArr.push(this.editTableData[i]);
                        }
                        this.$refs.lookupComSortTable.setCheckboxRow(checkboArr, true);
                    });
                    this.rowDrop();
                });
            },
            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.lookupComSortTable
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.editTableData.splice(oldIndex, 1)[0];
                            this.editTableData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
            getUpdateEvent(){
                let updateRecords = this.$refs.lookupComSortTable.getCheckboxRecords();
                for (let ii in updateRecords) {
                    updateRecords[ii].isSort = "1";
                }
                this.searTypeLookup = 'sort'
                this.lookupUserSortDtos = updateRecords
                this.initdata()
                this.searchSortVis = false
            }
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        }
    };
</script>
